import { useQuery } from '@tanstack/react-query'
import { getPromptDeliveryProducts } from 'src/service/promptDeliveryService'
import { useResellerContext } from '../useResellerContext'
import { QUERY_DATA } from 'src/service'

export const usePromptDelivery = () => {
  const resellerContext = useResellerContext()
  const { data, isLoading } = useQuery(
    [QUERY_DATA.PROMPT_DELIVERY],
    async () => {
      if (resellerContext?.isGenericUser || !resellerContext?.reseller) {
        return []
      }

      const promptDeliveryResponse = await getPromptDeliveryProducts({
        reseller: resellerContext?.reseller,
        pagination: { page: 1, page_size: 30 },
      })

      return promptDeliveryResponse.products
    },
    {
      refetchOnWindowFocus: false,
    },
  )

  return {
    isLoading,
    data,
  }
}
